module.exports = __webpack_public_path__ + "img/havefun_title-tc.a203b4ea.jpg";